import { iconUrl } from "./serviceIcons";

// Одна иконка сервиса. Всегда декоративна: рядом с ней стоит название, и
// дублировать его для читалки экрана — значит заставить человека выслушать
// одно и то же дважды.
const ServiceIcon = ({ slug, className = "h-full w-full" }) => (
  <img
    src={iconUrl(slug)}
    alt=""
    aria-hidden="true"
    loading="lazy"
    decoding="async"
    draggable="false"
    className={className}
  />
);

export default ServiceIcon;
